import SaveMessageDialog from '~/components/shared/SaveMessageDialog';
import React, {useState} from 'react';
import {View} from 'react-native';
import {Divider} from 'react-native-paper';
import isFinite from 'lodash/isFinite';
import sy from '~/styles';
import {
  Pressable,
  PrimaryButton,
  ServiceRequestStatusIcon,
  InputChatFloating,
} from '~/components/controls';
import {RobRequestErrorsDialog} from '~/components/shared/Dialogs';
import {service_request as serviceRequestApi} from '~/api/private';
import {STATUS_CODES} from '~/types/statuses';
import {canInvoice, isArchived, isNotReadyForInvoicing} from '~/types/rob';
import {ROB_REPLACEMENT_STAGE} from '~/types/replacement';
import {Tabs} from '~/types/tabs';
import ErrorIcon from '~/images/md-icons/error/materialicons/24px.svg';
import StageButton from './StageButton';
import PropTypes from 'prop-types';
const renderStatusIcon = (status) => (
  <ServiceRequestStatusIcon
    status={status}
    fill="#FFFFFF"
    iconProps={{
      width: 18,
      height: 18,
    }}
  />
);
const Footer = ({
  disabled,
  stageDisabled,
  hasSLA,
  car,
  kilometrage,
  invoiceNumber,
  status,
  is_fleet_car,
  rob,
  fleet_request,
  replacement,
  invoice,
  onRequest,
  onFinish,
  onInvoice,
  onRefresh,
  onChangeTab,
}) => {
  const [showRobErrorsDialog, setShowRobErrorsDialog] = useState(false);
  const [showSaveMessageDialog, setShowSaveMessageDialog] = useState(false);
  const [pendingMessage, setPendingMessage] = useState(null);
  const onSendChatMessage = async () => {
    const {success} = await serviceRequestApi.send_message(
      replacement.request_id,
      pendingMessage,
    );
    if (success) {
      setPendingMessage(null);
      onRefresh();
    }
  };
  const onSendChatAttachment = async (attachment) => {
    const {success} = await serviceRequestApi.send_attachment(
      replacement.request_id,
      attachment,
    );
    if (success) {
      onRefresh();
    }
  };
  const isInvoiceable = canInvoice(fleet_request?.status ?? rob?.rob_status);
  const isFinished = [STATUS_CODES.Done, STATUS_CODES.DoneNoInvoice].includes(
    status,
  );
  const showDoneButton = isInvoiceable && !isFinished;
  const invoiceIsBlocked =
    (!invoiceNumber && !invoice?.bahnkick_can_invoice) ||
    (fleet_request ?? rob)?.invoicing?.status !== 'ReadyForInvoicing';
  const renderInvoiceButton = (isBlocked) => (
    <PrimaryButton
      disabled={isBlocked}
      style={[sy.uppercase]}
      onPress={onInvoice}
      icon={renderStatusIcon(STATUS_CODES.Invoiced)}>
      Factureren
    </PrimaryButton>
  );
  const renderFooterActionButton = () => {
    if (showDoneButton) {
      return (
        <PrimaryButton
          style={[sy.uppercase]}
          disabled={isNotReadyForInvoicing(
            (fleet_request ?? rob)?.invoicing?.status,
          )}
          onPress={onFinish}
          icon={renderStatusIcon(STATUS_CODES.Done)}>
          Gereed melden
        </PrimaryButton>
      );
    }

    // Once the replacement is completed there is no stage action left to take,
    // even when the ROB request itself is not approved: the invoice is the only
    // remaining step.
    if (isInvoiceable || isFinished) {
      return renderInvoiceButton(invoiceIsBlocked);
    }
    return (
      <StageButton
        stage={stage}
        disabled={disabled || stageDisabled}
        onPress={async () => {
          if (pendingMessage?.length > 0) {
            setShowSaveMessageDialog(true);
            return true;
          }
          await onRequest();
        }}
      />
    );
  };
  if (
    isArchived(fleet_request?.status ?? rob?.rob_status) ||
    [STATUS_CODES.Cancelled, STATUS_CODES.Invoiced].includes(status)
  ) {
    return <></>;
  }
  let stage = ROB_REPLACEMENT_STAGE.reservation;
  if (hasSLA) {
    if (car?.license && isFinite(kilometrage)) {
      stage = ROB_REPLACEMENT_STAGE.checkin;
    } else if (car?.license) {
      stage = ROB_REPLACEMENT_STAGE.checkout;
    }
  }
  return (
    <>
      <>
        {!disabled && (
          <InputChatFloating
            is_rob={!is_fleet_car}
            message={pendingMessage}
            onChange={setPendingMessage}
            onSend={onSendChatMessage}
            onAttachment={onSendChatAttachment}
            onViewSentMessage={() => onChangeTab(Tabs.Messages)}
          />
        )}
        <SaveMessageDialog
          showSaveMessageDialog={showSaveMessageDialog}
          setShowSaveMessageDialog={setShowSaveMessageDialog}
          onSendChatMessage={onSendChatMessage}
        />
      </>
      <Divider style={sy['bg-gray88']} />
      <View
        style={[
          sy['bg-white'],
          sy['flex-row'],
          sy['justify-end'],
          sy['items-center'],
          sy['py-3'],
          sy['px-4'],
        ]}>
        <View style={[sy['flex-row'], sy['items-center'], sy['gap-4']]}>
          {rob?.errors?.length > 0 && (
            <Pressable onPress={() => setShowRobErrorsDialog(true)}>
              <ErrorIcon fill="#972727" />
            </Pressable>
          )}
          {renderFooterActionButton()}
        </View>
      </View>
      {showRobErrorsDialog && (
        <RobRequestErrorsDialog
          robErrors={rob?.errors}
          onDismiss={() => setShowRobErrorsDialog(false)}
        />
      )}
    </>
  );
};
Footer.propTypes = {
  disabled: PropTypes.any,
  stageDisabled: PropTypes.any,
  hasSLA: PropTypes.any,
  car: PropTypes.any,
  kilometrage: PropTypes.any,
  invoiceNumber: PropTypes.any,
  status: PropTypes.any,
  is_fleet_car: PropTypes.any,
  rob: PropTypes.any,
  fleet_request: PropTypes.any,
  replacement: PropTypes.any,
  invoice: PropTypes.any,
  onRequest: PropTypes.any,
  onFinish: PropTypes.any,
  onInvoice: PropTypes.any,
  onRefresh: PropTypes.any,
  onChangeTab: PropTypes.any,
};
export default Footer;
